import { render, staticRenderFns } from "./ExternalPrenotazioniPazienteModalComponent.vue?vue&type=template&id=3ca4fbb1"
import script from "./ExternalPrenotazioniPazienteModalComponent.vue?vue&type=script&lang=js"
export * from "./ExternalPrenotazioniPazienteModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports